import { useMemo } from "react";
import { useWatch } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import { deriveCommercial } from "./commercialTerms";

export function CommercialTermsPreview() {
  const basis = useWatch<Record<string, string>>({
    name: "first_tranche_payment_basis",
  });
  const pattern = useWatch<Record<string, string>>({
    name: "payment_terms_pattern",
  });
  const creditDays = useWatch<Record<string, string>>({
    name: "credit_days",
  });

  const derived = useMemo(
    () => deriveCommercial(basis, pattern, creditDays),
    [basis, pattern, creditDays],
  );

  return (
    <Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 2,
          mb: 1.5,
        }}
      >
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              letterSpacing: 0.5,
              textTransform: "uppercase",
              fontSize: 10,
              fontWeight: 700,
              display: "block",
            }}
          >
            Advance Applicable
          </Typography>
          <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
            {derived.advanceApplicable}
            <Box
              component="span"
              sx={{ color: "text.disabled", fontSize: 11, ml: 0.75, fontWeight: 400 }}
            >
              · derived
            </Box>
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              letterSpacing: 0.5,
              textTransform: "uppercase",
              fontSize: 10,
              fontWeight: 700,
              display: "block",
            }}
          >
            Advance %
          </Typography>
          <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
            {derived.advancePercent}
            <Box
              component="span"
              sx={{ color: "text.disabled", fontSize: 11, ml: 0.75, fontWeight: 400 }}
            >
              · derived
            </Box>
          </Typography>
        </Box>
      </Box>

      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          letterSpacing: 0.5,
          textTransform: "uppercase",
          fontSize: 10,
          fontWeight: 700,
          display: "block",
          mb: 0.5,
        }}
      >
        Payment Terms Remarks · SYSTEM-GENERATED
      </Typography>
      <Box
        sx={{
          bgcolor: "background.paper",
          border: 1,
          borderColor: "#E0E4EF",
          borderRadius: "6px",
          p: 1.25,
          fontSize: 13,
          color: "text.primary",
          lineHeight: 1.5,
        }}
      >
        {derived.remarks}
      </Box>
    </Box>
  );
}

export default CommercialTermsPreview;
